import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PaymentMethodsList } from './PaymentMethodsList';

export const PaymentMethodsPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#FFFCEF]">
      <header className="bg-[#2C2731] text-[#FFFCEF]">
        <div className="mx-auto flex max-w-4xl items-center justify-between px-4 py-3">
          <button
            onClick={() => navigate('/profile')}
            className="rounded-full p-2 hover:bg-[#FFFCEF]/10 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#FFFCEF] focus-visible:ring-offset-2 focus-visible:ring-offset-[#2C2731]"
          >
            <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>
          <span className="text-base font-semibold">Payment Methods</span>
          <img src="/gclogo.webp" alt="Guides Collective" className="h-8 w-auto" />
        </div>
      </header>

      <div className="mx-auto max-w-4xl px-4 py-6">
        <div className="mb-6 rounded-2xl border border-[#2C2731] bg-[#FFFCEF] p-4 shadow-sm">
          <p className="text-sm text-[#2C2731]/80">
            Manage your saved payment methods. Your payment information is securely stored by Stripe.
          </p>
        </div>

        <div className="rounded-2xl border border-[#2C2731] bg-[#FFFCEF] p-4 shadow-sm">
          <PaymentMethodsList />
        </div>
      </div>
    </div>
  );
};
